/**
 * Simply remove the no-js classname from the document body
 */
export const updateBodyClassname = () => {
	document.body.classList.remove('no-js');

	const scrollButt = document.querySelector('.scroll-down');

	if (scrollButt) {
		scrollButt.onclick = function () {
			window.scrollTo({
				top: 500,
				behavior: 'smooth',
			});
		};
	}

	/* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
	let prevScrollpos = window.pageYOffset;
	/* Get the header element and it's position */
	const headerDiv = document.querySelector('header');
	const headerHidden = document.querySelector('body');
	const headerSpacer = document.getElementById('header-spacer');
	const headerBottom = headerDiv.offsetTop + headerDiv.offsetHeight;

	if (headerSpacer) {
		headerSpacer.style.height = `${headerDiv.offsetHeight - 2}px`;
	}
	window.onscroll = function () {
		const currentScrollPos = window.pageYOffset;
		/* if we're scrolling up, or we haven't passed the header,
		 show the header at the top */
		if (
			prevScrollpos > currentScrollPos ||
			currentScrollPos < headerBottom
		) {
			/* if the user is logged in add 30px to the header hide to keep the full header on screen and not have it cut off*/
			const isLoggedin = document.getElementsByClassName('logged-in');
			if (isLoggedin.length > 0) {
				headerDiv.style.top = '30px';
				headerHidden.classList.remove('header-hidden');
			} else {
				headerDiv.style.top = '0';
				headerHidden.classList.remove('header-hidden');
			}
		} else {
			/* otherwise we're scrolling down & have passed the header so hide it */
			headerDiv.style.top = '-30rem';
			headerHidden.classList.add('header-hidden');
		}
		prevScrollpos = currentScrollPos;

		headerSpacer.style.height = `${headerDiv.offsetHeight - 2}px`;
	};

	window.onresize = function () {
		headerSpacer.style.height = `${headerDiv.offsetHeight - 2}px`;
	};
};
